import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'
import { KEY_INITIATIVE_STATUSES } from 'partner360/configs/keyInitiatives/keyInitiativeStatusesConfig'
import { TKeyInitiative } from 'partner360/entities/keyInitiatives'
import {
  getKeyInitiativeStatusTranslationKey,
  normalizeKeyInitiativeStatus,
} from 'partner360/entities/keyInitiatives/model/status'
import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'

import { KpiTile } from '../common/kpiTile/KpiTile'

import styles from './InitiativesByStatus.module.scss'

interface IInitiativesStatusCardContentProps {
  kiData: TKeyInitiative[]
}

export const InitiativesByStatus: FC<IInitiativesStatusCardContentProps> = ({ kiData }) => {
  const totalCount = kiData.length

  const statusesData = useMemo(() => {
    return KEY_INITIATIVE_STATUSES.map((status) => {
      const count = kiData.filter(
        (item) => normalizeKeyInitiativeStatus(item.Status) === status.key
      ).length

      return {
        ...status,
        count,
        percent: totalCount ? (count / totalCount) * 100 : 0,
      }
    })
  }, [kiData, totalCount])

  return (
    <KpiTile
      title={TRANSLATION_KEYS.dashboard.aggregatedView.initiativesByStatus.title}
      value={totalCount}
      footer={
        <>
          <div className={styles.legend}>
            {statusesData.map((status) => (
              <div key={status.key} className={styles.legendItem}>
                <span className={styles.legendMarker} style={{ backgroundColor: status.color }} />

                <span className={styles.legendText}>
                  <Translation span text={getKeyInitiativeStatusTranslationKey(status.key)} />
                  &nbsp;
                  {status.count}
                </span>
              </div>
            ))}
          </div>

          <div className={styles.bar}>
            {statusesData.map((status) =>
              status.count ? (
                <div
                  key={status.key}
                  className={styles.barSegment}
                  style={{
                    width: `${status.percent}%`,
                    backgroundColor: status.color,
                  }}
                />
              ) : null
            )}
          </div>
        </>
      }
    />
  )
}
